<template>
  <v-row no-gutters style="padding: 0 15px">
    <v-col v-if="is_fetching">
      <v-skeleton-loader type="image" />
    </v-col>
    <v-col v-else-if="!is_report_available">
      <v-alert text prominent type="error" icon="mdi-cloud-alert">
        {{ $t("common.labels.noReportAvailable") }}
      </v-alert>
    </v-col>
    <v-col v-else-if="chart_data && is_report_available && !is_fetching" class="ml-3">
      <v-row>
        <ReportDateSelect
          v-if="is_report_available"
          :allowed_dates="allowed_dates"
          :report_start_dates="report_start_dates"
          @week-selected="
            week_number = $event.week_number;
            year = $event.year;
          "
        />
      </v-row>
      <ScavengerReportHeading
        :tenant="tenant"
        :report_date="report_date"
        :report_time="report_time"
        :final_recepient="final_recepient"
        :recipients_number="recipients_number"
        report_period="weekly"
        :report_beginning_date="report_beginning_date"
      />
      <v-row no-gutters>
        <v-col cols="12" class="mb-2">
          <v-row no-gutters class="mb-2">
            <v-col cols="12" class="text-subtitle-1">Transformer Details</v-col>
          </v-row>
          <v-row no-gutters class="mb-4" v-if="device_details">
            <v-col cols="4">Transformer ID</v-col>
            <v-col cols="8">{{ device_details.DeviceID }}</v-col>
            <v-col cols="4">Transformer Location</v-col>
            <v-col cols="8">Dublin</v-col>
            <v-col cols="4">Transformer Coordinates</v-col>
            <v-col cols="8">{{ device_details.CurrentLat }}, {{ device_details.CurrentLng }}</v-col>
            <v-col cols="4">Transformer Rating</v-col>
            <v-col cols="8">{{ device_details.TransformerRating }} kW</v-col>
            <v-col cols="4">Feeders Connected</v-col>
            <v-col cols="8">{{ getActiveFeeders(device_details.ActiverFeeders) }}</v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row v-if="chart_data">
        <BarLightningChart :data="chart_data" :config="report_config" />
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import ReportDateSelect from "./ReportDateSelect.vue";
import BarLightningChart from "./BarLightningChart.vue";
import ScavengerReportHeading from "./ScavengerReportHeading.vue";
import { axios_get } from "../services/vt_service";
import { scv } from "../services/powerdata";
import { content as reports_config } from "../../config/scavenger_reports.js";
import { scavenger_grpc_services } from "../services/ScavengerServices";

const tenant_key = process.env["VUE_APP_TENANT_KEY"];

export default {
  name: "ScavengerHarmonicsReport",
  props: {
    device_id: String,
  },
  components: {
    ReportDateSelect,
    BarLightningChart,
    ScavengerReportHeading,
  },
  data: function () {
    return {
      page_content: null,
      report_config: null,
      year: null,
      week_number: null,
      allowed_dates: [],
      report_start_dates: [],
      harmonics_data: null,
      available_dates: null,
      is_report_available: false,
      chart_data: null,
      is_fetching: true,
      recepient: null,
      device_details: null,
    };
  },
  created() {
    //this.page_content = reports_config;
    this.report_config = reports_config;
  },
  mounted() {
    this.recepient = this.$auth.user.email;
    this.tenant = this.$auth.user[tenant_key]["tenant"];
    this.getScavengerAvailableReportDates();
    this.getDeviceDetails();
  },
  watch: {
    week_number: function (newVal, oldVal) {
      if (this.year && newVal !== oldVal) {
        this.harmonics_data = null;
        this.getHarmonicsReport();
      }
    },
  },
  methods: {
    async getScavengerAvailableReportDates() {
      this.network_error = false;
      await scavenger_grpc_services.GetScavengerAvailableReportDates(this.device_id, "en50160").then((response) => {
        this.is_fetching = false;
        this.available_dates = response;
        this.available_dates.length === 0 ? (this.is_report_available = false) : (this.is_report_available = true);
        if (this.is_report_available) {
          this.week_number = this.available_dates[0].week;
          this.year = this.available_dates[0].year;
          this.available_dates.map((week) => {
            if (week.availableDates) {
              this.allowed_dates.push(...week.availableDates);
              this.report_start_dates.push(week.availableDates[0]);
            }
          });
        }
      });

      // await axios_get(scv.get_scavenger_available_report_dates, {
      //   type: "en50160",
      //   id: this.device_id,
      // }).then((response) => {
      //   this.is_fetching = false;
      //   this.available_dates = response;
      //   this.available_dates.length === 0 ? (this.is_report_available = false) : (this.is_report_available = true);
      //   if (this.is_report_available) {
      //     this.week_number = this.available_dates[0].week;
      //     this.year = this.available_dates[0].year;
      //     this.available_dates.map((week) => {
      //       if (week.availableDates) {
      //         this.allowed_dates.push(...week.availableDates);
      //         this.report_start_dates.push(week.availableDates[0]);
      //       }
      //     });
      //   }
      // });
    },
    async getHarmonicsReport() {
      this.network_error = false;
      const response = await axios_get(scv.get_en50160_report, {
        type: "en50160",
        year: this.year,
        week: this.week_number,
        id: this.device_id,
      });
      if (response.length > 0) {
        this.harmonics_data = response[0];
        this.report_date = this.$formatDateFormat(
          this.harmonics_data.reportDates[this.harmonics_data.reportDates.length - 1]
        );
        this.report_beginning_date = this.$formatDateFormat(this.harmonics_data.reportDates[0]);
        this.report_time = this.$formatDate(this.harmonics_data.reportGeneratedAt);
        this.chart_data = this.setChartData(
          this.report_config.phases,
          this.report_config.harmonics_limit,
          this.harmonics_data.harmonics.values
        );
      }
    },
    setChartData(phases, limits, values) {
      let data = [];
      phases.map((phase) => {
        let sub_categories = [];
        sub_categories.push({ subCategory: "Limit", values: [...limits] });
        sub_categories.push({
          subCategory: "95 Percentile",
          values: [...values.perc_95[phase].map((val) => parseFloat(val))],
        });
        sub_categories.push({
          subCategory: "Mean",
          values: [...values.mean[phase].map((val) => parseFloat(val))],
        });
        data[phase] = sub_categories;
      });
      return data;
    },
    async getDeviceDetails() {
      this.network_error = false;
      // await axios_get(scv.get_scavenger_data, {
      //   id: this.device_id,
      // }).then((response) => {
      //   this.device_details = response[0];
      // });
      await scavenger_grpc_services.GetScavengerData(this.device_id).then((response) => {
        this.device_details = response[0];
      });
    },
    getActiveFeeders(active_feeders) {
      return active_feeders.toString().split("1").length - 1;
    },
  },
  computed: {
    final_recepient: function () {
      if (this.$route.name == "Report_Snapshot") {
        if (this.recipients_list && this.recipients_list.length > 0) {
          let recepients = "";
          let total = this.recipients_list.length;
          let limit = total > 7 ? 7 : total;
          for (var i = 0; i < limit; i++) {
            recepients = recepients
              ? recepients + "; " + this.recipients_list[i]["RecipientEmail"]
              : this.recipients_list[i]["RecipientEmail"];
          }
          return recepients;
        }
        return this.recepient;
      }
      return this.recepient;
    },
    recipients_number: function () {
      if (this.$route.name == "Report_Snapshot") {
        if (this.recipients_list && this.recipients_list.length > 0) {
          let total = this.recipients_list.length;
          return total > 7 ? total - 7 : null;
        }
        return null;
      }
      return null;
    },
  },
};
</script>
